var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.224 0h-3.103c-.399 0-.727.3-.77.688A4.37 4.37 0 008 0H2.845A2.848 2.848 0 000 2.845v4.138a2.848 2.848 0 002.845 2.845h.776v1.81a2.33 2.33 0 002.327 2.328 2.33 2.33 0 002.328-2.328v-.636c0-.804.54-1.52 1.313-1.74l.756-.216v.006c0 .428.347.776.776.776h3.103A.776.776 0 0015 9.052V.776A.776.776 0 0014.224 0zM9.163 7.77a3.376 3.376 0 00-2.439 3.232v.636a.777.777 0 01-1.552 0V9.052a.776.776 0 00-.775-.776H2.845c-.713 0-1.293-.58-1.293-1.293V2.845c0-.713.58-1.293 1.293-1.293H8c.943 0 1.824.476 2.344 1.254v4.626l-1.182.338zm4.285.506h-1.551V1.552h1.551v6.724z",
    fill: "#D90606"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "30f6d37cd303aaf24f266e0d677545f1.svg";
export { MemoForwardRef as ReactComponent };